import { configureStore } from "@reduxjs/toolkit";
import editorSlice from './slice/editor'

const rootReducers = {
  editor: editorSlice
};


// Store
const store = configureStore( {
  reducer: rootReducers,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Désactive la vérification de sérialisation
    }),
  devTools: { // Limite Redux DevTools en dev seulement
    actionSanitizer: (action) =>
      action.type === "editor/updateExistingData" && action.payload
      ? { ...action, payload: "Payload too large to display" }
      : action,
    stateSanitizer: (state) => state.largeKey ? { ...state, largeKey: "Hidden due to size" } : state,
  },
} );

export default store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
